"use client"

import { ChevronUpDown } from "@medusajs/icons"
import { clx } from "@modules/common/components/ui"

type EngineSelectProps = {
  engines: string[]
  value: string
  onChange: (engine: string) => void
  className?: string
  "data-testid"?: string
}

// Native select styled like the shared NativeSelect, but with a selectable
// "All engines" default so shoppers can clear the engine filter again.
const EngineSelect = ({
  engines,
  value,
  onChange,
  className,
  "data-testid": dataTestid,
}: EngineSelectProps) => {
  return (
    <div
      className={clx(
        "relative flex items-center text-base-regular border border-ui-border-base bg-ui-bg-subtle rounded-md hover:bg-ui-bg-field-hover",
        className
      )}
    >
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label="Engine"
        className="appearance-none flex-1 bg-transparent border-none px-4 py-2.5 pr-10 transition-colors duration-150 outline-none"
        data-testid={dataTestid}
      >
        <option value="">All engines</option>
        {engines.map((engine) => (
          <option key={engine} value={engine}>
            {engine}
          </option>
        ))}
      </select>
      <span className="absolute right-4 inset-y-0 flex items-center pointer-events-none">
        <ChevronUpDown />
      </span>
    </div>
  )
}

export default EngineSelect
